module.exports = __webpack_public_path__ + "img/model_11.454d1743.jpg";